import axios from "axios";
import { API_URL } from "configs";
import {
  APPRAISAL_TYPES_PATHS,
  mapApiAppraisalType,
  normalizeList,
} from "./constants";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchAppraisalTypes = async (objectViewedId, params = {}) => {
  const response = await axios.get(`${API_URL}${APPRAISAL_TYPES_PATHS.list}`, {
    headers: authHeaders(),
    params: {
      ...(objectViewedId ? { object_viewed_id: objectViewedId } : {}),
      ...params,
    },
  });

  return normalizeList(response.data).map(mapApiAppraisalType);
};

export const fetchAppraisalTypeOptions = async (objectViewedId) => {
  const response = await axios.get(
    `${API_URL}${APPRAISAL_TYPES_PATHS.options}`,
    {
      headers: authHeaders(),
      params: objectViewedId ? { object_viewed_id: objectViewedId } : undefined,
    }
  );

  return normalizeList(response.data).map((row) => ({
    value: row.id,
    label: row.name,
    id: row.id,
    code: row.code,
    name: row.name,
  }));
};

export const fetchAppraisalTypeById = async (id, objectViewedId) => {
  const response = await axios.get(
    `${API_URL}${APPRAISAL_TYPES_PATHS.byId(id)}`,
    {
      headers: authHeaders(),
      params: objectViewedId ? { object_viewed_id: objectViewedId } : undefined,
    }
  );

  const payload = response.data?.data ?? response.data;
  return mapApiAppraisalType(payload);
};

export const createAppraisalType = async (payload) => {
  const response = await axios.post(
    `${API_URL}${APPRAISAL_TYPES_PATHS.list}`,
    payload,
    { headers: authHeaders() }
  );
  const data = response.data?.data ?? response.data;
  return mapApiAppraisalType(data);
};

export const updateAppraisalType = async (id, payload) => {
  const response = await axios.put(
    `${API_URL}${APPRAISAL_TYPES_PATHS.byId(id)}`,
    payload,
    { headers: authHeaders() }
  );
  const data = response.data?.data ?? response.data;
  return mapApiAppraisalType(data);
};

export const deleteAppraisalType = async (id, objectViewedId) => {
  await axios.delete(`${API_URL}${APPRAISAL_TYPES_PATHS.byId(id)}`, {
    headers: authHeaders(),
    data: objectViewedId ? { object_viewed_id: objectViewedId } : {},
  });
};
